import { Payload } from "./../../services/botDialogTest";
import { iWorkspaces } from "../../types/iWorkspaces";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface FlowChanges {
  whatsappQrCode: boolean;
  refreshAllDialogs: boolean;
  showModalContacts: boolean;
  contactId: number;
  nameContact: string;
  selectedContactAvatarUrl: string;
  replyMessage?: ReplyMessagePayload | null;
  modalEdit: boolean;
  showCreateContact: boolean;
  isUploadingFile: boolean;
}

const initialState: FlowChanges = {
  whatsappQrCode: false,
  refreshAllDialogs: false,
  showModalContacts: false,
  contactId: 0,
  nameContact: "",
  selectedContactAvatarUrl: "",
  replyMessage: null,
  modalEdit: true,
  showCreateContact: false,
  isUploadingFile: false
};

export interface ReplyMessagePayload {
  id: number;
  dialogId: number;
  message: string;
  files: any[];
  date: string;
  updatedAt?: string;
  reply: boolean;
  isHumanResponder: boolean;
  robotName: string;
  chatName: string;
  humanName?: string;
}

const omnichannelSlice = createSlice({
  name: "workspaces",
  initialState,
  reducers: {
    setWhatsappQrCode(state, action: PayloadAction<boolean>) {
      state.whatsappQrCode = action.payload;
    },
    setRefreshAllDialogs(state, action: PayloadAction<boolean>) {
      state.refreshAllDialogs = action.payload;
    },
    setShowModalContacts(state, action: PayloadAction<boolean>) {
      state.showModalContacts = action.payload;
    },
    setContactId(state, action: PayloadAction<number>) {
      state.contactId = action.payload;
    },
    setNameContact(state, action: PayloadAction<string>) {
      state.nameContact = action.payload;
    },
    setSelectedContactAvatarUrl(state, action: PayloadAction<string>) {
      state.selectedContactAvatarUrl = action.payload;
    },
    setReplyMessage(state, action: PayloadAction<ReplyMessagePayload | null>) {
      state.replyMessage = action.payload;
    },
    setModalEdit(state, action: PayloadAction<boolean>) {
      state.modalEdit = action.payload;
    },
    setShowCreateContact(state, action: PayloadAction<boolean>) {
      state.showCreateContact = action.payload;
    },
    setIsUploadingFile(state, action: PayloadAction<boolean>) {
      state.isUploadingFile = action.payload;
    }
  }
});

export const {
  setWhatsappQrCode,
  setRefreshAllDialogs,
  setShowModalContacts,
  setContactId,
  setNameContact,
  setSelectedContactAvatarUrl,
  setReplyMessage,
  setModalEdit,
  setShowCreateContact,
  setIsUploadingFile
} = omnichannelSlice.actions;

export default omnichannelSlice.reducer;
